<template>
    <div
        :style="cursor"
        class="d-flex flex-column flex-md-row align-items-center"
        @click="$emit('click')"
    >
        <avatar
            class="mr-2"
            :size="45"
            :src="evaluation.evaluated.picture"
            :username="evaluation.evaluated.name"
        />
        <div
            class="d-flex flex-column justify-content-center align-items-center align-items-md-start mb-1 mb-md-0"
        >
            <span
                class="text-center"
                style="font-size: 16px; font-weight: bold; color: #707070"
            >
                {{
                    $t(`values.table.${evaluation.type}`) +
                    ' | ' +
                    evaluation.evaluated.name
                }}
            </span>
            <span class="text-center" style="font-size: 14px; color: #707070">
                <span>
                    {{
                        $t('values.questionnaire') +
                        ': ' +
                        evaluation.questionnaire_title
                    }}
                </span>
                <span
                    v-if="
                        evaluation.status === 'declined' &&
                        evaluation.questionnaire_is_closed
                    "
                >
                    {{ ' | ' + $t('values.closed') }}
                </span>
            </span>
        </div>
        <div class="d-flex align-items-center ml-md-auto">
            <b-button
                id="btn-values-declined-evaluation"
                v-if="evaluation.status === 'pending' && evaluation.can_decline"
                size="sm"
                class="mr-2"
                variant="outline-primary"
                :disabled="evaluation.decliningEvaluationLoader"
                @click.stop="$emit('decline-evaluation')"
            >
                <div
                    v-if="evaluation.decliningEvaluationLoader"
                    class="pl-2 pr-2"
                >
                    <i class="fa fa-spinner fa-spin px-2" />
                </div>
                <span v-else> {{ $t('values.decline') }} </span>
            </b-button>
            <b-button
                id="btn-values-answer-evaluation"
                v-if="evaluation.status === 'pending' && !evaluation.is_editing"
                size="sm"
                class="mr-2"
                variant="primary"
                :disabled="evaluation.enableEvaluationEditionLoader"
                @click.stop="$emit('enable-evaluation-edition')"
            >
                <div
                    v-if="evaluation.enableEvaluationEditionLoader"
                    class="pl-2 pr-2"
                >
                    <i class="fa fa-spinner fa-spin px-2" />
                </div>
                <span v-else>{{ $t('values.answerEvaluation') }}</span>
            </b-button>
            <b-button
                v-if="
                    evaluation.status === 'sent' &&
                    evaluation.can_edit &&
                    !evaluation.is_editing &&
                    !evaluation.questionnaire_is_closed
                "
                size="sm"
                class="mr-2"
                variant="outline-primary"
                :disabled="evaluation.enableEvaluationEditionLoader"
                @click.stop="$emit('enable-evaluation-edition')"
            >
                <div
                    v-if="evaluation.enableEvaluationEditionLoader"
                    class="pl-2 pr-2"
                >
                    <i class="fa fa-spinner fa-spin px-2" />
                </div>
                <span v-else> {{ $t('values.editEvaluation') }}</span>
            </b-button>
            <b-button
                v-if="
                    evaluation.status === 'declined' &&
                    !evaluation.questionnaire_is_closed
                "
                size="sm"
                variant="primary"
                :disabled="evaluation.acceptingEvaluationLoader"
                @click.stop="$emit('accept-evaluation')"
            >
                <div
                    v-if="evaluation.acceptingEvaluationLoader"
                    class="pl-2 pr-2"
                >
                    <i class="fa fa-spinner fa-spin px-2" />
                </div>
                <span v-else>{{ $t('values.accept') }} </span>
            </b-button>
        </div>
    </div>
</template>

<script>
import Avatar from 'vue-avatar'

export default {
    components: {
        Avatar,
    },
    props: {
        evaluation: {
            type: Object,
            required: true,
        },
    },
    computed: {
        cursor() {
            return this.evaluation.is_editing ||
                this.evaluation.status !== 'pending'
                ? 'cursor: pointer'
                : ''
        },
    },
}
</script>
